<template>
    <div class="main-license">
        <header>
            <h3>许可证</h3>
            <span>/ {{ this.currencyData.title }}</span>
        </header>
        <main>
            <!-- 表格搜索栏 -->
            <div class="toolbar">
                <div class="search-bar">
                    <!-- <a-form-model :model="pagination" ref="searchBar" :layout="formLayout">
                        <a-form-model-item prop="searchText">
                            <a-input-search v-model="pagination.searchText" placeholder="搜索"
                                style="width: 200px; margin-right: 16px" allow-clear :loading="btnLoad"
                                @input="searchTextChange" />
                        </a-form-model-item>
                        <a-form-model-item prop="licenseState">
                            <a-select
                                v-model="pagination.licenseState"
                                placeholder="许可证状态"
                                style="width: 180px; margin-right: 16px"
                                :loading="btnLoad"
                                allowClear
                                @change="searchChange"
                            >
                                <a-select-option :value="0">未许可</a-select-option>
                                <a-select-option :value="1">已许可</a-select-option>
                            </a-select> 
                            </a-form-model-item>
                    </a-form-model> -->
                </div>
                <div class="btn-group">
                    <!-- <a-button icon="redo" @click="resetSearch">重 置</a-button> -->
                    <a-button style="margin-right:10px" icon="arrow-left" @click="returnOpen('返回')">返回许可</a-button>
                </div>
            </div>
            <!-- 数据表格 -->
            <a-table :columns="tableColumns" :data-source="tableData" @change="handleTableChange"  :pagination="queryCondition" :loading="btnLoad">
                <template slot="licenseState" slot-scope="text">
                    <span v-if="text === 0">
                        <a-tag color="blue">已许可</a-tag>
                    </span>
                    <span v-if="text === 1">
                        <a-tag color="cyan">未许可</a-tag>
                    </span>
            
                </template>
            </a-table>
        </main>

    </div>
</template>

<script>
export default {
    props: ['currencyData'],
    data() {
        return {
            btnLoad: false,
            tableLoad: false,
            submitLoad: false,
            pagination: {
                searchText: "",
                licenseState: undefined,
                pageSize: 10,
                pageNo: 1,
                current: 1,
                total: 0,
                type:'',
                showQuickJumper: true,
                showSizeChanger: true,
                pageSizeOptions: ['10', '20', '30', '40', '50'],
                showTotal: (total, range) => `显示 ${range[0]} 到 ${range[1]} ，共 ${total} 条记录  `
            },
            formLayout: "inline",
            queryCondition: {},

            tableData: [],
            // 模态框显隐
            modalVisible: false,
            // 模态框标题
            modalTitle: "",
            // 添加/修改保存API
            saveApi: "",
            // 单行数据
            singleDta: {},
            // 表格头
            tableColumns: []
        };
    },
    methods: {
        // 重置表单通用方法
        resetForm() {
            if (this.modalTitle == '添加' || this.modalTitle == '修改') {
                this.$refs.deptForm.resetFields()
            }
            this.modalVisible = false
        },
        // 重置搜索
        resetSearch() {
            this.$refs.searchBar.resetFields()
            this.searchChange()
        },

        // 监听搜索输入框输入
        searchTextChange(val) {
            if (window.searchTimer) {
                clearTimeout(searchTimer);
            }
            window.searchTimer = setTimeout(() => {
                this.searchChange(val)
            }, 1200);
        },
        // 搜索
        searchChange(v) {
            this.queryCondition = this.$lodash.cloneDeep(this.pagination)
            
            this.tableAjax()
        },
        // 监听翻页
        handleTableChange(pagination, filters, sorter) {
            this.queryCondition.pageNo = pagination.current
            this.queryCondition.current = pagination.current
            this.queryCondition.pageSize = pagination.pageSize
            this.tableAjax()
        },
        // 翻页请求
        tableAjax() {
            this.queryCondition.type =  this.$cookies.get('SingleTriggenData').type
            this.tableLoad = true;
            this.axios
                .post("/license/findPageByType",this.$qs.stringify(this.queryCondition))
                .then((res) => {
                       this.tableLoad = false;
                    if (res.code === 200) {
                        this.tableData = res.data.list;
                        this.queryCondition.total = res.data.total;
                    }
                })
                .catch((err) => {
                    console.log(err);
                    this.tableLoad = false;
                });
        },
        // 返回
        returnOpen() {
            this.$emit("close", 'license');
        },
    },
    beforeMount() {
        switch (this.$cookies.get('SingleTriggenData').title) {
            case "Attended":
                this.tableColumns = [
                    {
                        title: "用户名",
                        dataIndex: "machineName",
                        key: "machineName",
                    },
                    {
                        title: "IP地址",
                        dataIndex: "ipAddress",
                        key: "ipAddress",
                    },
                    {
                        title: "计算机名称",
                        dataIndex: "robotName",
                        key: "robotName",
                    },
                    {
                        title: "许可证状态",
                        dataIndex: "licenseState",
                        key: "licenseState",
                        scopedSlots: { customRender: "licenseState" },
                    },
                ]
                break;
            case "Unattended":
                this.tableColumns = [
                    {
                        title: "计算机",
                        dataIndex: "machineName",
                        key: "machineName",
                    },
                    {
                        title: "IP地址",
                        dataIndex: "ipAddress",
                        key: "ipAddress",
                    },
                    {
                        title: "机器人名称",
                        dataIndex: "robotName",
                        key: "robotName",
                    },
                    {
                        title: "许可证状态",
                        dataIndex: "licenseState",
                        key: "licenseState",
                        scopedSlots: { customRender: "licenseState" },
                    },
                ]
                break;
            case "Studio":
                this.tableColumns = [
                    {
                        title: "用户名",
                        dataIndex: "machineName",
                        key: "machineName",
                    },
                    {
                        title: "IP地址",
                        dataIndex: "ipAddress",
                        key: "ipAddress",
                    },
                    {
                        title: "许可证状态",
                        dataIndex: "licenseState",
                        key: "licenseState",
                        scopedSlots: { customRender: "licenseState" },
                    },
                ]
                break;

        }
        this.searchChange();
    },
};
</script>
<style lang="scss" scoped>
.main-license {
    header {
        display: flex;
        align-items: flex-end;
        margin: -7px -8px 0;
        padding: 16px;
        letter-spacing: 1px;
        background-color: #fff;

        h3 {
            margin-bottom: 0;
          line-height:16px;
            padding-left: 12px;
            border-left: 4px solid #3373f2;
            font-size: 18px;
            //font-weight: bold;
        }

        span {
            line-height: 16px;
            margin-left: 10px;
            color: #808080;
        }
    }

    main {
        margin: 16px 8px;
        background-color: #fff;
        padding: 0 16px;
        box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.1), 0 4px 5px 0 rgba(0, 0, 0, 0.07),
            0 1px 10px 0 rgba(0, 0, 0, 0.06);
        border-radius: 4px;

        .toolbar {
            display: flex;
            justify-content: space-between;
            padding: 16px 0;
        }
    }
}
</style>